
import React, { useEffect, useState } from "react";
import './tableStyle.css';

export declare type InputProps = {
    data: any,
    columns: any,
    children?: JSX.Element | JSX.Element[],
}


export const TablePage = ({ data, columns, children }: InputProps) => {
    const [listData, setListData] = useState<any>([]);

    useEffect(() => {
        if (data) {
            setListData(data)
        }
    }, [data]);

    return (
        <div className="Ctable-parent">
            <table className="Ctable">
                <tr className="Ctable-head">
                    {columns.map((item: any) =>
                        <th >
                            <span>{item.title}</span>
                        </th>
                    )}
                </tr>
                {listData.map((item: any, index: number) =>
                    <tr key={index} className="Ctable-row" >
                        {columns.map((items: any) =>
                            <td >
                                {item[items.dataIndex]}
                                {item[items.dataIndex] == undefined && items.render(item)}
                            </td>
                        )}
                    </tr>
                )}
            </table>
            {listData.length == 0 &&
                <div className=" w-full h-[200px] rounded-[10px] flex flex-col justify-center items-center bg-white shadow">
                    <svg x="0px" y="0px" viewBox="0 0 502 502" className={`w-[60px] fill-dayan-gray-100 `}>
                        <use xlinkHref="/assetes/svg/find.svg#find" />
                    </svg>
                    <span className="text-sm mt-6">هیچ داده ای برای نمایش وجود ندارد</span>
                </div>
            }
            {listData.length > 0 &&
                <div className="Ctable-counter">
                    {children}
                </div>
            }
        </div>
    )
}
